/*
 * @Author: JamesWong
 * @Description: 支付配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: James Wong
 * @Last Modified time: 2019-04-08 14:13:13
 */
export default {
  channelPaymentMethods: 'Channel Payment Methods',
  set: 'Set',
  setPaymentMethods: 'Set Payment Methods',
  confirm: 'Confirm',
  cancel: 'Cancel',
  channel: 'Channel',
  order: 'Order',
  channelNumber: 'Channel No.',
  account: 'Account',
  accountFilter: 'Account Filters',
  weChatScanPayment: 'WeChat Scan',
  paymentSetTips: 'Hint: When editing multiple channels at the same time, you have to select payment method again, or the method will be set as empty',
  pleaseSelectAgain: 'Please select again',
  selectPaymentMethod: 'Select payment method',
  paymentNumber: 'Payment No.',
  merchantID: 'Merchant ID',
  submerchantID: 'Sub-merchant ID',
  Note: 'Note',
  appId: '商户ID',
  token: '授权Token',
  tokenTime: '授权时间',
  wechatFaceIDPay: 'Wechat Face',
  wechatClientSelfpay: 'Wechat Self-buy',
  alipayScancodePay: 'Ali Scan',
  alipayNumber: 'Alipay Number',
  systemBusinessNumber: 'System Business Number',
  enterChannelTips: 'Please enter channel Number/name to search',
  channelName: 'Channel Name',
  wechatPaymentDisposition: 'Wechat Payment',
  wechatPaymentTips: 'Wechat pay support three types of payment:',
  wechatPaymentTips1: '1.Scan pay: Cashier scans client’s payment code, applicable for POS;',
  wechatPaymentTips2: '2.cashier FaceID pay: Client finish Face-scanning payment on certain machine, applicable for self-shopping machine Client;',
  wechatPaymentTips3: '3.self-pay: Client click payment button on personal mobile to open Wechat pay, applicable for Wechat shopping center and scan-pay program.',
  wechatPaymentTipsPlus: 'Note: The three types can only default with one payment each. When channel has not disposed payment methods independently, it will automatically use default payment method. ',
  Mode: 'Mode',
  type: 'Type',
  default: 'default',
  defaultTips: 'Default',
  operate: 'Operate',
  detail: 'Detail',
  paymentMethodDetail: 'Payment Method Detail',
  paymentType: 'Payment Type',
  APPKEY: 'APPKEY',
  certification: 'Certification',
  certificationDocument: 'Certification Document',
  certificationPassword: 'Certification Password',
  alipayPaymentDisposition: 'Alipay Payment',
  status: 'Status',
  authorizedMerchantID: 'Authorized MID',
  unAuthorized: 'Unauthorized',
  authorize: 'Authorize',
  authorized: 'Authorized',
  privateKey: 'Private Key',
  publicKey: 'Public Key',
  signatureType: 'Signature Type',
  selectedTips: 'Pls select channel befor set paymend method',
  success: 'Success',
  configuredChannel: 'Configured Channel',
  reauthorize: 'Reauthorize'
}



// WEBPACK FOOTER //
// ./src/i18n/en/payment.js